/**
 * ### DISTRIBUTOR
 *
 * This is a list of UIDs of the distributors that are supported by the system.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DISTRIBUTOR: any = Object.freeze({
  MOCHIPAY: 'MOCHIPAY',
  AUTOPASS: 'AUTOPASS',
  CATHAYMR: 'CATHAYMR',
  CPCPAY: 'CPCPAY',
  CITIMKT: 'CITIMKT',
  LINE_BANK: 'LINE_BANK',
  WAFFLE: 'WAFFLE',
  IKNOW99: 'IKNOW99',
  AUTO_PARTNER: 'AUTO_PARTNER',
  NPCPAY: 'NPCPAY',
  ENTERPRISE: 'ENTERPRISE',
  RICHART_LIFE: 'RICHART_LIFE',
  MYTOYOTA: 'MYTOYOTA',
  LEXUS_PLUS: 'LEXUS_PLUS',
  DENDEN: 'DENDEN',
  PLUS_PAY: 'PLUS_PAY',
  ENTERPRISE_JKO: 'ENTERPRISE_JKO',
  ENTERPRISE_PI: 'ENTERPRISE_PI',
  UAT: 'UAT',
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DISTRIBUTOR_NAME: any = Object.freeze({
  MOCHIPAY: '麻吉付',
  AUTOPASS: '車麻吉',
  CATHAYMR: '國泰優惠',
  CPCPAY: '中油Pay',
  CITIMKT: '行動市集',
  LINE_BANK: 'Line Bank',
  WAFFLE: '窩福',
  IKNOW99: 'iKnow99',
  AUTO_PARTNER: 'AutoPartner',
  NPCPAY: '全國',
  ENTERPRISE: '企業方案',
  RICHART_LIFE: 'Richart Life',
  MYTOYOTA: 'Toyota',
  LEXUS_PLUS: 'Lexus Plus',
  DENDEN: '電電',
  PLUS_PAY: '全盈',
  UAT: 'UAT',
});
